import React, {useEffect} from "react";
import {Route, Routes, useLocation} from "react-router-dom";
import Header from "../common/header/header";
import Footer from "../common/footer/footer";
import Dashboard from "../undergraduate/ugdashboard";
import Sidebar from "../common/sidebar/sidebar";
import StartApplication from "../startapplication/application";
import LandingPage from "../landingpage/applicationlandingpage";
import Ugdashboard from "../undergraduate/ugdashboard";
import AdmissionType from "../undergraduate/admission-type";
import PersonalInfo from "../undergraduate/personal-info";
import GuardianInfo from "../undergraduate/guardian-info";
import UndergraduateDocument from "../undergraduate/document";
import UndergraduateDashboard from "../undergraduate/ugdashboard";
import ApplicationRegistration from "../registrationpage/register";
import ForgotPassword from "../loginpage/forgot-password";
import UGApplicationPreview from "../undergraduate/preview";
import PgPersonalInfo from "../postgraduate/personal-info";
import PostgraduateDashboard from "../postgraduate/pgdashboard";
import AcademicQualification from "../postgraduate/academic-qualifications";
import EmploymentDetails from "../postgraduate/employment-details";
import PostgraduateDocument from "../postgraduate/document";
import PGApplicationPreview from "../postgraduate/preview";
import NewStudentEnrolment from "../new-student-enrolment/new-student-enrolment";
import ChangePassword from "../loginpage/change-password";
import AdmissionLetterLandingPage from "../admission-letter/landing";
import Olevel from "../undergraduate/Olevel";
import Jamb from "../undergraduate/jamb";
import LoginFromStaff from "../loginpage/login-from-staff";

export default function PageRoutes() {
    return(<>
                <Routes>
                    <Route exact path="/application" element={<StartApplication />} />

                    <Route exact path="/undergraduate/dashboard" element={<UndergraduateDashboard />} />
                    <Route exact path="/undergraduate/admission-type" element={<AdmissionType />} />
                    <Route exact path="/undergraduate/personal-Information" element={<PersonalInfo />} />
                    <Route exact path="/undergraduate/secondary-school-result" element={<Olevel />} />
                    <Route exact path="/undergraduate/jamb-result" element={<Jamb />} />
                    <Route exact path="/undergraduate/guardian-Information" element={<GuardianInfo />} />
                    <Route exact path="/undergraduate/document-uploads" element={<UndergraduateDocument />} />
                    <Route exact path="/undergraduate/application-preview" element={<UGApplicationPreview />} />

                    <Route exact path="postgraduate/dashboard" element={<PostgraduateDashboard />} />
                    <Route exact path="postgraduate/personal-Information" element={<PgPersonalInfo />} />
                    <Route exact path="postgraduate/academic-qualifications" element={<AcademicQualification />} />
                    <Route exact path="postgraduate/employment-details" element={<EmploymentDetails />} />
                    <Route exact path="postgraduate/document-uploads" element={<PostgraduateDocument />} />
                    <Route exact path="postgraduate/application-preview" element={<PGApplicationPreview />} />

                    <Route path="/application/enrolment" element={<NewStudentEnrolment/>} />
                    <Route path="/admission-letter/:slug" element={<AdmissionLetterLandingPage/>} />

                    <Route exact path="/login-from-staff" element={<LoginFromStaff />} />


                    <Route exact path="/" element={<LandingPage/>} />
                    <Route path="/login" element={<LandingPage />} />
                    <Route path="/register" element={<ApplicationRegistration />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/change-password/:token" element={<ChangePassword/>} />
                </Routes>

    </>
);
}
